import React from "react";
import { Route } from "react-router-dom";
import SeoWrapper from "components/dashboard/common/SeoWrapper/SeoWrapper";
import { connect } from "react-redux";
import TabbedWrapperRouter from "../TabbedWrapperRouter/TabbedWrapperRouter";
import { pathTypes } from "routes/enum";
import NoPermission from "pages/PublicPages/ErrorPages/NoPermission/NoPermission";
import {
    roleHasPermission,
    mapStateToRolePermissions,
} from "utils/permissions/rolePermissions";

const { SINGLE, TABBED, DROPDOWN } = pathTypes;

const AccessControlRoute = ({
    baseResources,
    path,
    title,
    isExact,
    pathType,
    tabs,
    component: Component,
    role,
}) => {
    const renderBasedOnRouteType = () => {
        switch (pathType) {
            case SINGLE:
            case DROPDOWN:
                return (
                    <Route
                        exact={false}
                        path={path}
                        render={(props) => (
                            <SeoWrapper title={title}>
                                <Component title={title} {...props} />
                            </SeoWrapper>
                        )}
                    />
                );
            case TABBED:
                return (
                    <Route
                        exact={isExact ? true : false}
                        path={path}
                        render={() => (
                            <TabbedWrapperRouter tabbedRoutes={tabs} />
                        )}
                    />
                );
            default:
                return (
                    <Route
                        exact={false}
                        path={path}
                        render={(props) => (
                            <SeoWrapper title={title}>
                                <Component title={title} {...props} />
                            </SeoWrapper>
                        )}
                    />
                );
        }
    };
    const hasAccess = roleHasPermission(role, baseResources);

    return <>{hasAccess ? renderBasedOnRouteType() : <NoPermission />}</>;
};

export default connect((state) => ({
    ...mapStateToRolePermissions(state),
    role: state?.auth?.user?.role,
}))(AccessControlRoute);
